
import React from 'react';
import AMCConstants from './AMCConstants';
import ZNetwork from "./znetwork.js";
import ZUtil from "./zutil.js";
import ZProps from "./zprops.js";
import ZLog from "./zlog.js";
import { APP } from "./App.js";
import AMC from "./AMC.js";
import { ROUTER } from "./AMCRouter.js";
import { AUTH } from './AMCAuth';
import AMCForm from './AMCForm';
import ZooUserPage from './ZooUserPage';
import PleaseStandBy from "./PleaseStandBy";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

export default class ZooUserAccountPage extends React.Component {
	constructor(props) {
		super(props);
		this.state = { selected: "account" };
	}
	componentDidMount() {
		AMC.getPricingPlans((err, plans) => {
			if (!err) {
				this.setState({ plans: plans });
			} else {
				this.setState({ error: err });
			}
		});
		this.onSelectTab(this.props.selected || this.state.selected);
		ZProps.set("page_has_changed", false);
	}
	onSelectTab(label) {
		label = label.toLowerCase();
		switch (label) {
			case "billing" :
				ROUTER.pushRoute("/billing");
				break;
			case "profile" :
				ROUTER.pushRoute("/" +  ZProps.get("user").uri);
				break;
			case "account" :
				break;
			case "plan" :
				break;
			case "apikey" :
				break;
			default:
				ZLog.warn("Unknown tab: " + label);
				break;
		}
		this.setState({selected: label});
	}
	onCancel() {
		//this.onSelectTab(this.state.selected);
		window.location.reload();
	}
	onSave(properties) {
		ZLog.debug("ZooUserAccountPage.onSave properties", {properties: properties});
		let user = ZProps.get("user");
		let settings = ZProps.get("usersettings");
		//let privates = ZProps.get("usersettings");
		let PRIMARY_PROPERTIES = ["name", "email", "tagline", "avatar", "apikey", "plan"];
		//let SETTINGS_PROPERTIES = ["bio", "banner", "occupation", "organization", "country", "website", "linkedin", "github", "twitter"];
		//let PRIVATES_PROPERTIES = ["emailable", "wtfs", "freakouts", "helpmechooses", "rockpile" ];
		Object.keys(properties).forEach( key => {
			if (PRIMARY_PROPERTIES.indexOf(key) !== -1) {
// tmp fix of bug where bio can overwhelm size of cookies since usersettings kept in session
				user[key] = properties[key];
			} else { // if (SETTINGS_PROPERTIES.indexOf(key) !== -1) {
				settings[key] = properties[key];
			}
		});
		//ZProps.set("user", user);
		//ZProps.set("usersettings", settings);
		AMC.saveUser(user, settings, (err, saved) => {
			if (err) {
				this.setState({ error: err });
			} else {
				this.setState({ saved: Date.now() });
			}
		});
	}
	onDeleteAccount(e) {
		ZUtil.absorbEvent(e);
		APP.areYouSure(() => {
			ZNetwork.post("destroy", ZProps.get("user").uri, null, null, (err) => {
				AUTH.signOut();
			});
		});
	}
	onAPIKeyButton(cmd) {
		if (cmd === "expire") {
			ZNetwork.post("apikey/expire", (err, new_apikey) => {
				if (err) {
					APP.setError(err); // "Unable to expire api token");
				} else {
					let user = ZProps.get("user");
					user.apikey = new_apikey;
					AMC.setUser(user);
					this.setState({ saved: Date.now() });
				}
			});
		}
	}
	onSubscriptionButton(cmd) {
		if (cmd === "upgrade") {
			ROUTER.pushRoute(AMCConstants.PRICING_URI);
		} else if (cmd === "change") {
			this.setState({ showplans: true });
		} else if (cmd === "none") {
			// cancel
			APP.areYouSure(() => {
				ZNetwork.post("checkout:cancelsubscription", (err, result) => {
					if (!err) {
						ZProps.set("user", result.user);
						ZProps.set("usersettings", result.settings);
						this.forceUpdate();
					}
				});
			}, "Are you sure you want to cancel your subscription plan?");
		} else {
			APP.areYouSure(() => {
				ZNetwork.post("checkout:changesubscription", { plan_level: cmd }, (err, results) => {
					if (!err) {
						AMC.setUser(results.user);
						APP.setBanner(results.msg);
						this.forceUpdate();
					}
				});
			}, "Are you sure you want to change your subscription plan?");
		}
	}
	render() {
		let { selected, saved, showplans, plans } = this.state;
		let user = ZProps.get("user");
		let usersettings = ZProps.get("usersettings") || {};
		let payload = [];
		let values = Object.assign({}, usersettings, user);
		if (!plans) {
			return <PleaseStandBy />;
		}
		let PLANS = plans ? plans.subscriptions.map( p => p.monthly.level ).concat(["none"]) : [];
		let subs = { cmds: ["upgrade", "change"], labels: ["Upgrade", "Change"] }
		if (user.plan === "guest" || user.plan === "member" ) {
			subs = { cmds: ["upgrade"], labels: ["Upgrade"] }
		} else if (user.plan === "business") {
			subs = { cmds: ["change"], labels: ["Change"] }
		}
			
console.log("PLANS=" + PLANS);
		switch (this.state.selected) {
			case "account" :
				let fields = [
					{ name: "Name", field: "name", kind: "string", minlen: 3, maxlen: 64, placeholder: "", required: true },
					{ name: "Username", field: "uri", kind: "string", disabled: true, minlen: 8, maxlen: 64 },
					{ name: "Email", field: "email", kind: "string", minlen: 8, maxlen: 64, placeholder: "", required: true },
					{ name: "Email preferences", field: "emailable", kind: "boolean", defaultValue: true, required: false },
					{ name: "Tagline", field: "tagline", kind: "string", minlen: 0, maxlen: 64, placeholder: "Something cool", required: false },
					{ name: "Bio", field: "bio", kind: "text", minlen: 0, maxlen: 256, placeholder: "Something about you", required: false },
					{ name: "Avatar", field: "avatar", kind: "cloudinary", folder: "avatars", size: "thumb", label: "Upload image", required: false, defaultvalue: values.avatar },
					{ name: "Occupation", field: "occupation", kind: "string", minlen: 3, maxlen: 64, placeholder: "", required: false },
					{ name: "Organization", field: "organization", kind: "string", minlen: 3, maxlen: 64, placeholder: "", required: false },
					{ name: "Country", field: "country", kind: "string", minlen: 3, maxlen: 64, placeholder: "", required: false },
					{ name: "Website URL", field: "website", kind: "url", minlen: 8, maxlen: 64, placeholder: "", required: false },
					{ name: "LinkedIn URL", field: "linkedin", kind: "url", minlen: 8, maxlen: 64, placeholder: "", required: false },
					{ name: "Github username", field: "github", kind: "string", minlen: 2, maxlen: 20, placeholder: "", required: false },
					{ name: "Twitter username", field: "twitter", kind: "string", minlen: 2, maxlen: 20, placeholder: "", required: false },
					{ name: "Banner", field: "banner", kind: "cloudinary", folder: "banners", size: "large", label: "Upload image", required: false, defaultvalue: values.banner },
					{ name: "API Token", field: "apikey", kind: "string", placeholder: "", disabled: true, required: false, buttons: {labels: ["Create new API token"], cmds: ["expire"], callback: this.onAPIKeyButton.bind(this) } },
					{ name: "Subscription plan", field: "plan", kind: "string", placeholder: "", required: false, disabled: true, hidden: showplans, buttons: { labels: subs.labels, cmds: subs.cmds, callback: this.onSubscriptionButton.bind(this) } },
					{ name: "Choose plan", field: "plans", kind: "annotation", hidden: !showplans, force: true, annotation: <div>{ PLANS.map( p => <button key={p} className={"AMCButton" + (p === user.plan ? " AMCFormFieldDisabled" : "")} disabled={p === user.plan ? true : false} onClick={e => this.onSubscriptionButton(p)}>{p}</button> ) }</div> },
					{ name: "WTFs", field: "wtfs", kind: "annotation", annotation: <a className="ZooUserAccountLink" href={"/zoo/" + AMC.getSettingURI("wtf")}>{AMC.getSettingURI("wtf")}</a> },
					{ name: "Freakouts", field: "freakouts", kind: "annotation", annotation: <a className="ZooUserAccountLink" href={"/zoo/" + AMC.getSettingURI("freakout")}>{AMC.getSettingURI("freakout")}</a> },
					{ name: "Help Me Choose", field: "helpmechooses", kind: "annotation", annotation: <a className="ZooUserAccountLink" href={"/zoo/" + AMC.getSettingURI("helpmechoose")}>{AMC.getSettingURI("helpmechoose")}</a> },
					{ name: "Rockpile", field: "rockpile", kind: "annotation", annotation: <a className="ZooUserAccountLink" href={"/zoo/" + AMC.getSettingURI("rockpile")}>{AMC.getSettingURI("rockpile")}</a> },
					{ name: "Theme pack", field: "themes", kind: "annotation", annotation: <a className="ZooUserAccountLink" href={"/zoo/" + AMC.getSettingURI("themes")}>{AMC.getSettingURI("themes")}</a> },
				];
				payload = <AMCForm key={saved + showplans} fields={fields} values={values} onSave={this.onSave.bind(this)} saveButton={ saved ? <span><FontAwesomeIcon icon={faCheck} /><span> Save</span></span> : "Save" } onCancel={this.onCancel.bind(this)} cancelButton={ "Cancel" } buttons={<button className="AMCButton AMCButtonDeleteAccount" onClick={this.onDeleteAccount.bind(this)}>Close account...</button>} />
				break;
			case "plan" :
				break;
			case "apikey" :
				break;
			default:
				ZLog.warn("Unknown tab selected: " + this.state.selected);
				break;
		}
console.log("key=" + saved + showplans + "page");
		return (
			<ZooUserPage user={user} key={saved + showplans + "page"} usersettings={usersettings} tabs={["profile"]} rightsides={["billing"]} selected={selected} onSelectTab={this.onSelectTab.bind(this)}>
				{payload}
			</ZooUserPage>
		);

	}
}




// WEBPACK FOOTER //
// ./src/ZooUserAccountPage.js